import styled from 'styled-components';

interface IRootProps {
  heightFull?: boolean;
  widthValue?: string;
  heightValue?: string;
  dragging?: boolean;
}

export const Root = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  cursor: ${(props: IRootProps) => (props.dragging ? 'grab' : '')};
  &:active{
    cursor: ${(props: IRootProps) => (props.dragging ? 'grabbing' : '')};
  }
`;
